import { useQuery } from "react-query";

import { dropdownValuesService } from "services";
import { ProcessorSponsorPageName } from "types";

export type UseProcessorQueryProps = {
	applicationId?: string;
	pageName?: ProcessorSponsorPageName;
	options?: any;
};

const useProcessorsQuery = ({
	applicationId,
	pageName,
	options,
}: UseProcessorQueryProps = {}) => {
	return useQuery(
		["processors", applicationId, pageName],
		() => dropdownValuesService.getProcessors(applicationId, pageName),
		options,
	);
};

export default useProcessorsQuery;
